// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Morpho-style Homepage CSS */

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.morpho-home {
  width: 100%;
  min-height: 100vh;
  background: #000000;
  color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', sans-serif;
  position: relative;
  overflow-x: hidden;
}

/* Navigation */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.95);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.navbar-container {
  width: 100%;
  max-width: 1280px;
  padding: 0 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nav-right {
  display: flex;
  align-items: center;
}

.nav-logo {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
}

.logo-image {
  height: 120px;
  width: auto;
  object-fit: contain;
  cursor: pointer;
  transition: all 0.3s ease;
}

.logo-image:hover {
  opacity: 0.8;
}

.nav-menu {
  display: flex;
  gap: 36px;
  align-items: center;
  margin-right: 32px;
}

.nav-actions {
  display: flex;
  align-items: center;
  gap: 36px;
  flex: 0 0 auto;
}

.nav-item {
  font-family: 'FK Grotesk', -apple-system, BlinkMacSystemFont, sans-serif;
  color: rgba(255, 255, 255, 0.5);
  font-size: 20px;
  font-weight: 400;
  line-height: 160%;
  cursor: pointer;
  transition: color 0.2s ease;
  position: relative;
  letter-spacing: 0.3px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.nav-item:hover {
  color: rgba(255, 255, 255, 0.85);
}

.nav-item .dropdown-arrow {
  font-size: 12px;
  opacity: 0.6;
  transition: transform 0.2s ease;
}

.nav-item:hover .dropdown-arrow {
  transform: rotate(180deg);
}

.dropdown {
  display: flex;
  align-items: center;
  gap: 6px;
}

.dropdown-arrow {
  font-size: 10px;
  opacity: 0.5;
}

.launch-btn {
  font-family: 'FK Grotesk', -apple-system, BlinkMacSystemFont, sans-serif;
  padding: 10px 24px;
  background: #4A90E2;
  color: white;
  border: none;
  border-radius: 24px;
  font-size: 20px;
  font-weight: 400;
  line-height: 160%;
  cursor: pointer;
  transition: all 0.2s ease;
  letter-spacing: 0.3px;
}

.launch-btn:hover {
  background: #5A9FF2;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
}

/* Mobile Menu Toggle */
.mobile-menu-toggle {
  display: none;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  justify-content: center;
}

.hamburger-line {
  width: 24px;
  height: 2px;
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  display: block;
}

.mobile-menu-toggle:hover .hamburger-line {
  background: #ffffff;
}

@media (max-width: 768px) {
  .mobile-menu-toggle {
    display: flex;
  }
  
  .nav-menu {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.98);
    backdrop-filter: blur(20px);
    flex-direction: column;
    padding: 2rem;
    gap: 1.5rem;
    transform: translateY(-100%);
    transition: transform 0.3s ease;
    z-index: 999;
    display: flex;
  }
  
  .nav-menu.mobile-open {
    transform: translateY(0);
  }
  
  .nav-item {
    font-size: 18px;
    padding: 10px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
}

.hero-section {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 48px;
  padding-top: 80px;
  position: relative;
}

.hero-title {
  font-size: 32px;
  font-weight: 300;
  line-height: 1.2;
  text-align: center;
  margin-bottom: 20px;
  letter-spacing: -0.5px;
  max-width: 700px;
  animation: fadeInUp 1s ease;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.hero-subtitle {
  font-size: 16px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.5);
  text-align: center;
  margin-bottom: 48px;
  max-width: 500px;
  animation: fadeInUp 1s ease 0.2s;
  animation-fill-mode: both;
  font-weight: 300;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

/* Sphere Container */
.sphere-container {
  width: 500px;
  height: 500px;
  margin: 60px auto;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
}

/* Metrics */
.metrics {
  position: absolute;
  bottom: 60px;
  left: 48px;
  display: flex;
  gap: 60px;
  animation: fadeInUp 1s ease 0.8s;
  animation-fill-mode: both;
}

.metric-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.metric-item label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 400;
}

.metric-value {
  font-size: 24px;
  font-weight: 500;
  color: #ffffff;
  letter-spacing: -0.5px;
}

/* Scroll Indicator */
.scroll-indicator {
  position: absolute;
  bottom: 60px;
  right: 48px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  animation: fadeIn 1s ease 1s;
  animation-fill-mode: both;
}

/* Update Particle Sphere Container Styles */
.particles-sphere-container {
  width: 100%;
  height: 100%;
  position: relative;
}

.particles-canvas {
  width: 100% !important;
  height: 100% !important;
}

.sphere-logo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border-radius: 50%;
}

.logo-v {
  font-size: 32px;
  font-weight: 300;
  color: #ffffff;
  opacity: 0.9;
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Responsive */
@media (max-width: 1280px) {
  .navbar-container {
    padding: 0 32px;
  }
  
  .hero-title {
    font-size: 52px;
  }
  
  .section-container {
    max-width: 1100px;
  }
}

@media (max-width: 1024px) {
  .logo-image {
    height: 100px;
  }
  
  .nav-item {
    font-size: 18px;
  }
  
  .launch-btn {
    font-size: 18px;
    padding: 8px 20px;
  }
  
  .hero-title {
    font-size: 44px;
  }
  
  .sphere-container {
    width: 400px;
    height: 400px;
    border-radius: 50%;
  }
  
  .value-cards {
    flex-direction: column;
    max-width: 600px;
    margin: 0 auto;
  }
  
  .value-card {
    width: 100%;
  }
  
  .tech-features {
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    padding: 0 2rem;
  }
}

@media (max-width: 768px) {
  /* Navigation */
  .navbar {
    height: 60px;
    padding: 0 20px;
  }
  
  .navbar-container {
    padding: 0 0;
  }
  
  .logo-image {
    height: 80px;
  }
  
  .nav-right {
    gap: 20px;
  }
  
  .nav-menu {
    display: none;
  }
  
  .launch-btn {
    font-size: 14px;
    padding: 8px 16px;
  }
  
  /* Hero Section */
  .hero-section {
    padding: 0 20px;
    padding-top: 100px;
  }
  
  .hero-title {
    font-size: 32px;
    line-height: 1.3;
  }
  
  .hero-subtitle {
    font-size: 16px;
    padding: 0 20px;
  }
  
  .sphere-container {
    position: relative;
    width: 500px;
    height: 500px;
    margin: 60px auto;
    border-radius: 50%;
    overflow: hidden;
  }
  
  .metrics {
    position: relative;
    left: auto;
    bottom: auto;
    flex-direction: row;
    justify-content: center;
    gap: 30px;
    margin-top: 40px;
  }
  
  .scroll-indicator {
    display: none;
  }
  
  /* Partners Section */
  .partners-section {
    padding: 4rem 1rem;
    min-height: auto;
  }
  
  .section-title {
    font-size: 32px;
  }
  
  .section-subtitle {
    font-size: 16px;
  }
  
  /* Value Cards */
  .value-cards {
    gap: 20px;
  }
  
  /* Technology Section */
  .technology-section {
    padding: 4rem 1rem;
  }
  
  .tech-features {
    grid-template-columns: 1fr;
    gap: 2.5rem;
    padding-top: 40px;
  }
  
  .tech-feature {
    max-width: 300px;
    margin: 0 auto;
  }
  
  .feature-icon {
    font-size: 2.5rem;
  }
  
  .tech-feature h4 {
    font-size: 20px;
  }
  
  .tech-feature p {
    font-size: 16px;
  }
  
  /* Code Block */
  .code-block-container {
    padding: 0 1rem;
    margin: 2rem 0;
  }
  
  .code-tabs {
    flex-wrap: wrap;
    gap: 1rem;
  }
  
  .code-tab {
    font-size: 14px;
    padding: 8px 16px;
  }
  
  .code-window {
    max-width: 100%;
  }
  
  .code-content-wrapper {
    min-height: 400px;
    height: 50vh;
  }
  
  .code-block-container .code-content {
    padding: 2rem;
    font-size: 14px;
    line-height: 24px;
  }
}

@media (max-width: 480px) {
  /* Mobile Navigation */
  .logo-image {
    height: 60px;
  }
  
  .nav-item {
    display: none;
  }
  
  .launch-btn {
    font-size: 13px;
    padding: 6px 14px;
    border-radius: 18px;
  }
  
  /* Hero Section */
  .hero-title {
    font-size: 28px;
  }
  
  .hero-subtitle {
    font-size: 14px;
    line-height: 1.6;
  }
  
  .sphere-container {
    width: 250px;
    height: 250px;
    border-radius: 50%;
  }
  
  .metric {
    font-size: 12px;
  }
  
  .metric-value {
    font-size: 20px;
  }
  
  /* Sections */
  .section-title {
    font-size: 28px;
    margin-bottom: 1rem;
  }
  
  .section-subtitle {
    font-size: 14px;
    margin-bottom: 2rem;
  }
  
  /* Tech Features */
  .feature-icon {
    font-size: 2rem;
  }
  
  .tech-feature h4 {
    font-size: 18px;
  }
  
  .tech-feature p {
    font-size: 14px;
  }
  
  /* Code Block */
  .code-tab {
    font-size: 12px;
    padding: 6px 12px;
  }
  
  .code-block-container .code-content {
    padding: 1.5rem;
    font-size: 12px;
    line-height: 20px;
  }
  
  .code-content-wrapper {
    min-height: 300px;
  }
  
  /* CTA Section */
  .cta-title {
    font-size: 28px;
  }
  
  .cta-subtitle {
    font-size: 14px;
  }
  
  .cta-buttons {
    flex-direction: column;
    gap: 1rem;
  }
  
  .cta-btn {
    width: 100%;
    padding: 12px 24px;
  }
  
  /* Footer */
  .footer-section {
    padding: 3rem 1rem;
  }
  
  .footer-content {
    flex-direction: column;
    gap: 2rem;
    text-align: center;
  }
  
  .footer-links {
    flex-direction: column;
    gap: 1rem;
  }
  
  .footer-link {
    font-size: 14px;
  }
}

/* Partners Section */
.partners-section {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6rem 2rem;
  background: #000000;
}

.section-container {
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}

.section-title {
  font-size: 48px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 1.5rem;
  letter-spacing: -1px;
}

.section-subtitle {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.6);
  text-align: center;
  margin-bottom: 4rem;
  line-height: 1.6;
}

/* Partner Logos */
.partners-container {
  position: relative;
  width: 100%;
  overflow: hidden;
  padding: 2rem 0;
}

.partners-row {
  display: flex;
  gap: 2rem;
  white-space: nowrap;
}

.partner-logo {
  flex-shrink: 0;
  padding: 1rem;
}

.logo-box {
  width: 180px;
  height: 80px;
  border-radius: 12px;
  border: 1px solid;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

/* Solutions Section */
.solutions-section {
  min-height: 100vh;
  padding: 6rem 2rem;
  background: #000000;
}

.value-cards-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-top: 4rem;
}

.value-card {
  background: rgba(10, 10, 10, 0.8);
  border: 1px solid rgba(65, 105, 225, 0.2);
  border-radius: 20px;
  padding: 2rem;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  overflow: hidden;
  min-height: 400px;
  display: flex;
  flex-direction: column;
}

.value-card:hover {
  border-color: rgba(65, 105, 225, 0.5);
  background: rgba(65, 105, 225, 0.08);
  transform: translateY(-5px);
}

.card-content {
  flex: 1 1;
  margin-bottom: 2rem;
}

.card-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #ffffff;
}

.card-subtitle {
  font-size: 14px;
  font-weight: 400;
  color: rgba(65, 105, 225, 0.8);
  margin-bottom: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.card-description {
  font-size: 14px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.6);
}

.card-visual {
  background: rgba(0, 0, 0, 0.5);
  border-radius: 12px;
  padding: 1rem;
  margin-top: auto;
}

/* Dashboard Visual */
.visual-dashboard {
  font-size: 12px;
  width: 100%;
  height: 100%;
}

.dashboard-header {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid rgba(65, 105, 225, 0.2);
  padding-bottom: 0.5rem;
}

.dashboard-tab {
  padding: 0.25rem 0.5rem;
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.2s;
  font-size: 11px;
}

.dashboard-tab.active {
  color: #4169E1;
  border-bottom: 2px solid #4169E1;
}

.metric-row {
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.metric-label {
  color: rgba(255, 255, 255, 0.5);
}

.metric-value {
  color: #ffffff;
  font-weight: 500;
}

.metric-value.positive {
  color: #10b981;
}

.chart-placeholder {
  margin-top: 1rem;
  width: 100%;
  height: 60px;
}

.mini-chart {
  height: 60px;
  width: 100%;
  display: block;
}

/* Code Visual for Value Cards - Small Code Blocks */
.visual-code {
  font-size: 11px;
}

.visual-code .code-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  background: rgba(65, 105, 225, 0.1);
  border-radius: 8px 8px 0 0;
  margin-bottom: 0.5rem;
}

.visual-code .code-file {
  color: #4169E1;
  font-weight: 500;
  font-size: 11px;
}

.visual-code .code-dots {
  display: flex;
  gap: 4px;
}

.visual-code .code-dots span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
}

.visual-code .code-content {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 0 0 8px 8px;
  padding: 1rem;
  overflow-x: auto;
  max-height: 200px;
}

.visual-code .code-content pre {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
}

.visual-code .code-content code {
  color: #e2e8f0;
  font-family: 'Consolas', 'Monaco', monospace;
  font-size: 11px;
  line-height: 1.4;
}

/* Interface Visual */
.visual-interface {
  font-size: 12px;
}

.interface-header {
  margin-bottom: 1rem;
}

.interface-nav {
  display: flex;
  gap: 1rem;
  border-bottom: 1px solid rgba(65, 105, 225, 0.2);
  padding-bottom: 0.5rem;
}

.interface-nav .nav-item {
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  padding: 0.25rem 0;
  transition: all 0.2s;
}

.interface-nav .nav-item.active {
  color: #4169E1;
  border-bottom: 2px solid #4169E1;
}

.balance-card {
  background: rgba(65, 105, 225, 0.1);
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.balance-label {
  color: rgba(255, 255, 255, 0.5);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.balance-amount {
  color: #ffffff;
  font-size: 20px;
  font-weight: 600;
}

.position-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.position-item {
  display: flex;
  justify-content: space-between;
  padding: 0.75rem;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.position-token {
  color: #ffffff;
  font-weight: 500;
}

.position-apy {
  color: #10b981;
  font-weight: 500;
}

/* Responsive */
@media (max-width: 1200px) {
  .value-cards-grid {
    grid-template-columns: 1fr;
    max-width: 600px;
    margin: 4rem auto 0;
  }
}

/* Technology Section */
.technology-section {
  min-height: 100vh;
  padding: 6rem 2rem;
  background: #000000;
}

/* Code Block Styles */
.code-block-container {
  max-width: 100%;
  margin: 4rem 0;
  padding: 0 2rem;
}

.code-tabs {
  display: flex;
  gap: 2rem;
  margin-bottom: 2rem;
  border-bottom: 1px solid rgba(100, 150, 255, 0.1);
}

.code-tab {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  font-weight: 500;
  padding: 1rem 0;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
}

.code-tab:hover {
  color: rgba(100, 150, 255, 0.9);
}

.code-tab.active {
  color: #64B5F6;
}

.code-tab.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #64B5F6 0%, #42A5F5 100%);
}

.code-window {
  background: linear-gradient(135deg, #0d1117 0%, #0a0f1b 50%, #081320 100%);
  border: 1px solid rgba(100, 150, 255, 0.2);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(100, 150, 255, 0.15);
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
}

.code-block-container .code-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  background: linear-gradient(180deg, rgba(100, 150, 255, 0.05) 0%, transparent 100%);
  border-bottom: 1px solid rgba(100, 150, 255, 0.1);
}

.code-block-container .code-filename {
  color: #64B5F6;
  font-size: 14px;
  font-family: 'JetBrains Mono', 'Consolas', 'Monaco', monospace;
  font-weight: 500;
}

.code-actions {
  display: flex;
  gap: 1rem;
}

.code-action {
  background: rgba(100, 150, 255, 0.05);
  border: 1px solid rgba(100, 150, 255, 0.2);
  color: #64B5F6;
  font-size: 12px;
  padding: 0.25rem 0.75rem;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.code-action:hover {
  background: rgba(100, 150, 255, 0.15);
  border-color: rgba(100, 150, 255, 0.4);
  color: #90CAF9;
}

.code-content-wrapper {
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, rgba(13, 17, 23, 0.95) 0%, rgba(8, 19, 32, 0.98) 100%);
  min-height: 800px;
  height: 80vh;
  max-height: 900px;
  overflow: auto;
  position: relative;
}

.code-line-numbers {
  display: none; /* Hide line numbers */
}

.line-number {
  display: none; /* Hide line numbers */
}

.code-block-container .code-content {
  width: 100%;
  height: 100%;
  min-height: 800px;
  margin: 0;
  padding: 4rem;
  overflow: auto;
  background: transparent;
  color: #e0e6ed;
  font-family: 'JetBrains Mono', 'Fira Code', 'Consolas', monospace;
  font-size: 18px;
  line-height: 32px;
  letter-spacing: 0.8px;
  font-weight: 400;
  display: flex;
  flex-direction: column;
}

.code-block-container .code-content pre {
  margin: 0;
  padding: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: 32px;
  flex: 1 1;
  width: 100%;
  height: 100%;
}

.code-block-container .code-content code {
  display: block;
  white-space: pre;
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  line-height: 32px;
  width: 100%;
  height: 100%;
}

/* Syntax highlighting with light blue theme */
.code-content .keyword {
  color: #64B5F6;
  font-weight: 500;
}

.code-content .string {
  color: #81C784;
}

.code-content .comment {
  color: #546E7A;
  font-style: italic;
}

.code-content .number {
  color: #FFB74D;
}

.code-content .function {
  color: #4FC3F7;
  font-weight: 500;
}

.code-content .type {
  color: #BA68C8;
}

.code-content .variable {
  color: #90CAF9;
}

/* Scrollbar styling */
.code-content-wrapper::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.code-content-wrapper::-webkit-scrollbar-track {
  background: #0a0a0a;
}

.code-content-wrapper::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 5px;
}

.code-content-wrapper::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.2);
}

.tech-header {
  text-align: center;
  margin-bottom: 4rem;
}

.gradient-text {
  background: linear-gradient(135deg, #4169E1 0%, #5179F1 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.tech-features {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 3rem;
  max-width: 1000px;
  margin: 4rem auto 0;
}

.tech-feature {
  text-align: center;
  padding: 0;
  background: transparent;
  border: none;
  transition: all 0.3s ease;
}

.tech-feature:hover {
  transform: translateY(-5px);
}

.feature-icon {
  font-size: 2rem;
  margin-bottom: 0.5rem;
  color: rgba(255, 255, 255, 0.6);
}

.tech-feature h4 {
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 0.5rem;
}

.tech-feature p {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
}

/* CTA Section */
.cta-section {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6rem 2rem;
  background: #000000;
}

.cta-content {
  text-align: center;
}

.cta-title {
  font-size: 48px;
  font-weight: 600;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, #4169E1 0%, #5179F1 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.cta-subtitle {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 3rem;
}

.cta-buttons {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
}

.cta-primary {
  padding: 14px 32px;
  background: #4169E1;
  border: none;
  border-radius: 20px;
  color: white;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.cta-primary:hover {
  background: #5179F1;
  transform: translateY(-2px);
}

.cta-secondary {
  padding: 14px 32px;
  background: transparent;
  border: 2px solid rgba(65, 105, 225, 0.5);
  border-radius: 20px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.cta-secondary:hover {
  background: rgba(65, 105, 225, 0.1);
  border-color: #4169E1;
}

/* Footer */
.vega-footer {
  background: #0a0a0a;
  border-top: 1px solid rgba(65, 105, 225, 0.1);
  padding: 4rem 2rem 2rem;
}

.footer-container {
  max-width: 1400px;
  margin: 0 auto;
}

.footer-content {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 4rem;
  margin-bottom: 3rem;
}

.footer-brand p {
  color: rgba(255, 255, 255, 0.5);
  margin-top: 1rem;
}

.footer-logo {
  font-size: 20px;
  font-weight: 600;
}

.logo-accent {
  color: #4169E1;
}

.footer-links {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.footer-column h5 {
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 1rem;
}

.footer-column a {
  display: block;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  padding: 0.25rem 0;
  transition: color 0.3s ease;
}

.footer-column a:hover {
  color: #4169E1;
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 2rem;
  border-top: 1px solid rgba(65, 105, 225, 0.1);
  color: rgba(255, 255, 255, 0.5);
}

.footer-socials {
  display: flex;
  gap: 2rem;
}

.footer-socials a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-socials a:hover {
  color: #4169E1;
}

/* Hero Section Updates */
.hero-subtitle-large {
  font-size: 20px;
  line-height: 1.5;
  color: rgba(100, 150, 255, 0.9);
  text-align: center;
  margin-bottom: 24px;
  max-width: 600px;
  animation: fadeInUp 1s ease 0.15s;
  animation-fill-mode: both;
  font-weight: 500;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  letter-spacing: 0.5px;
}

.hero-description {
  font-size: 16px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.5);
  text-align: center;
  margin-bottom: 40px;
  max-width: 650px;
  animation: fadeInUp 1s ease 0.3s;
  animation-fill-mode: both;
  font-weight: 300;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.hero-cta-buttons {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  animation: fadeInUp 1s ease 0.45s;
  animation-fill-mode: both;
  margin-bottom: 20px;
}

/* About Section Cards */
.about-details-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  margin-top: 3rem;
}

.about-card {
  background: rgba(10, 10, 10, 0.8);
  border: 1px solid rgba(65, 105, 225, 0.2);
  border-radius: 16px;
  padding: 2rem;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.about-card:hover {
  border-color: rgba(65, 105, 225, 0.5);
  background: rgba(65, 105, 225, 0.08);
  transform: translateY(-4px);
}

.about-card h4 {
  font-size: 18px;
  font-weight: 600;
  color: #4169E1;
  margin-bottom: 1rem;
}

.about-card p {
  font-size: 15px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.7);
}

/* Second row of value cards */
.value-cards-grid-second {
  margin-top: 2rem;
}

/* Second row of tech features */
.tech-features-second {
  margin-top: 3rem;
}

/* Approach Section */
.approach-section {
  min-height: 80vh;
  padding: 6rem 2rem;
  background: #000000;
  display: flex;
  align-items: center;
}

.approach-pillars {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-top: 4rem;
}

.pillar-card {
  background: rgba(10, 10, 10, 0.8);
  border: 1px solid rgba(65, 105, 225, 0.2);
  border-radius: 20px;
  padding: 2.5rem;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  text-align: center;
}

.pillar-card:hover {
  border-color: rgba(65, 105, 225, 0.5);
  background: rgba(65, 105, 225, 0.08);
  transform: translateY(-5px);
}

.pillar-number {
  font-size: 48px;
  font-weight: 700;
  color: rgba(65, 105, 225, 0.3);
  margin-bottom: 1rem;
  font-family: 'Inter', sans-serif;
}

.pillar-card h3 {
  font-size: 22px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 1rem;
}

.pillar-card p {
  font-size: 15px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.6);
}

/* Contact Section */
.contact-content {
  width: 100%;
}

.contact-grid {
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 4rem;
  margin-top: 3rem;
  text-align: left;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.contact-info-card {
  background: rgba(10, 10, 10, 0.6);
  border: 1px solid rgba(65, 105, 225, 0.15);
  border-radius: 12px;
  padding: 1.25rem 1.5rem;
}

.contact-info-card h4 {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: rgba(65, 105, 225, 0.8);
  margin-bottom: 0.5rem;
}

.contact-info-card p {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
}

.contact-info-card a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.2s ease;
}

.contact-info-card a:hover {
  color: #4169E1;
}

/* Contact Form */
.contact-form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-group input,
.form-group textarea {
  background: rgba(10, 10, 10, 0.8);
  border: 1px solid rgba(65, 105, 225, 0.2);
  border-radius: 10px;
  padding: 12px 16px;
  color: #ffffff;
  font-size: 15px;
  font-family: 'Inter', sans-serif;
  transition: all 0.3s ease;
  outline: none;
}

.form-group input:focus,
.form-group textarea:focus {
  border-color: #4169E1;
  box-shadow: 0 0 0 3px rgba(65, 105, 225, 0.1);
}

.form-group textarea {
  resize: vertical;
  min-height: 120px;
}

.form-submit-btn {
  width: 100%;
  margin-top: 0.5rem;
}

.form-success {
  background: rgba(65, 105, 225, 0.1);
  border: 1px solid rgba(65, 105, 225, 0.3);
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
}

.form-success p {
  color: rgba(255, 255, 255, 0.8);
  font-size: 16px;
}

/* Footer Updates */
.footer-brand .footer-licence {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.4);
  margin-top: 0.75rem;
}

.logo-fzco {
  color: rgba(255, 255, 255, 0.5);
  font-weight: 400;
  font-size: 16px;
}

.footer-address {
  text-align: center;
  padding: 1.5rem 0;
  border-top: 1px solid rgba(65, 105, 225, 0.1);
  margin-top: 2rem;
}

.footer-address p {
  color: rgba(255, 255, 255, 0.4);
  font-size: 14px;
}

.footer-disclaimer {
  padding: 1.5rem 0;
  border-top: 1px solid rgba(65, 105, 225, 0.1);
}

.footer-disclaimer p {
  color: rgba(255, 255, 255, 0.35);
  font-size: 12px;
  line-height: 1.7;
  text-align: center;
  max-width: 900px;
  margin: 0 auto;
}

/* Responsive Updates */
@media (max-width: 1200px) {
  .about-details-grid {
    grid-template-columns: 1fr;
    max-width: 600px;
    margin: 3rem auto 0;
  }
  
  .approach-pillars {
    grid-template-columns: 1fr;
    max-width: 600px;
    margin: 4rem auto 0;
  }

  .contact-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
}

@media (max-width: 768px) {
  .hero-subtitle-large {
    font-size: 17px;
  }

  .hero-description {
    font-size: 14px;
    padding: 0 10px;
  }

  .hero-cta-buttons {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }

  .about-details-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  
  .approach-section {
    padding: 4rem 1rem;
  }

  .approach-pillars {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .contact-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .footer-links {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .footer-address,
  .footer-disclaimer {
    padding: 1rem 0;
  }
}

@media (max-width: 480px) {
  .hero-subtitle-large {
    font-size: 15px;
  }

  .hero-description {
    font-size: 13px;
  }

  .about-card {
    padding: 1.5rem;
  }

  .pillar-card {
    padding: 1.5rem;
  }

  .pillar-number {
    font-size: 36px;
  }

  .contact-info-card {
    padding: 1rem;
  }
}

/* End of styles */
`, "",{"version":3,"sources":["webpack://./src/styles/MorphoHomePage.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAI9B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,+EAA+E;EAC/E,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,wEAAwE;EACxE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,wEAAwE;EACxE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,+BAA+B;IAC/B,2BAA2B;IAC3B,sBAAsB;IACtB,aAAa;IACb,WAAW;IACX,4BAA4B;IAC5B,+BAA+B;IAC/B,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,eAAe;IACf,iDAAiD;EACnD;AACF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;EAC3B,+EAA+E;AACjF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;EAChB,+EAA+E;AACjF;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,SAAS;EACT,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,+BAA+B;EAC/B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA,4CAA4C;AAC5C;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,qCAAqC;IACrC,SAAS;IACT,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA,iBAAiB;EACjB;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA,qBAAqB;EACrB;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,gBAAgB;EAChB;IACE,SAAS;EACX;;EAEA,uBAAuB;EACvB;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,eAAe;EACf;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,sBAAsB;EACtB;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA,iBAAiB;EACjB;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,aAAa;EACb;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA,kBAAkB;EAClB;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,eAAe;EACf;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,gBAAgB;EAChB;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA,WAAW;EACX;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,iDAAiD;AACnD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,mCAAmC;EACnC,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,4CAA4C;EAC5C,eAAe;EACf,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;AAC9D;;AAEA;EACE,0EAA0E;EAC1E,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,iDAAiD;EACjD,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,mFAAmF;EACnF,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,8DAA8D;EAC9D,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0FAA0F;EAC1F,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa,EAAE,sBAAsB;AACvC;;AAEA;EACE,aAAa,EAAE,sBAAsB;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,cAAc;EACd,iEAAiE;EACjE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,SAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA,8CAA8C;AAC9C;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,6CAA6C;EAC7C,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB,gBAAgB;EAChB,+EAA+E;EAC/E,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;EAChB,+EAA+E;AACjF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,iCAAiC;EACjC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,oBAAoB;AACpB;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,iCAAiC;EACjC,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,yBAAyB;EACzB,aAAa;AACf;;AAEA;;EAEE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,kBAAkB","sourcesContent":["/* Morpho-style Homepage CSS */\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@300;400;500;600;700&display=swap');\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.morpho-home {\n  width: 100%;\n  min-height: 100vh;\n  background: #000000;\n  color: #ffffff;\n  font-family: -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', sans-serif;\n  position: relative;\n  overflow-x: hidden;\n}\n\n/* Navigation */\n.navbar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 72px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  background: rgba(0, 0, 0, 0.95);\n  backdrop-filter: blur(20px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.navbar-container {\n  width: 100%;\n  max-width: 1280px;\n  padding: 0 48px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.nav-right {\n  display: flex;\n  align-items: center;\n}\n\n.nav-logo {\n  display: flex;\n  align-items: center;\n  flex: 0 0 auto;\n}\n\n.logo-image {\n  height: 120px;\n  width: auto;\n  object-fit: contain;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.logo-image:hover {\n  opacity: 0.8;\n}\n\n.nav-menu {\n  display: flex;\n  gap: 36px;\n  align-items: center;\n  margin-right: 32px;\n}\n\n.nav-actions {\n  display: flex;\n  align-items: center;\n  gap: 36px;\n  flex: 0 0 auto;\n}\n\n.nav-item {\n  font-family: 'FK Grotesk', -apple-system, BlinkMacSystemFont, sans-serif;\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 160%;\n  cursor: pointer;\n  transition: color 0.2s ease;\n  position: relative;\n  letter-spacing: 0.3px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.nav-item:hover {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.nav-item .dropdown-arrow {\n  font-size: 12px;\n  opacity: 0.6;\n  transition: transform 0.2s ease;\n}\n\n.nav-item:hover .dropdown-arrow {\n  transform: rotate(180deg);\n}\n\n.dropdown {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.dropdown-arrow {\n  font-size: 10px;\n  opacity: 0.5;\n}\n\n.launch-btn {\n  font-family: 'FK Grotesk', -apple-system, BlinkMacSystemFont, sans-serif;\n  padding: 10px 24px;\n  background: #4A90E2;\n  color: white;\n  border: none;\n  border-radius: 24px;\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 160%;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  letter-spacing: 0.3px;\n}\n\n.launch-btn:hover {\n  background: #5A9FF2;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);\n}\n\n/* Mobile Menu Toggle */\n.mobile-menu-toggle {\n  display: none;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 8px;\n  flex-direction: column;\n  gap: 4px;\n  align-items: center;\n  justify-content: center;\n}\n\n.hamburger-line {\n  width: 24px;\n  height: 2px;\n  background: rgba(255, 255, 255, 0.8);\n  transition: all 0.3s ease;\n  display: block;\n}\n\n.mobile-menu-toggle:hover .hamburger-line {\n  background: #ffffff;\n}\n\n@media (max-width: 768px) {\n  .mobile-menu-toggle {\n    display: flex;\n  }\n  \n  .nav-menu {\n    position: fixed;\n    top: 60px;\n    left: 0;\n    right: 0;\n    background: rgba(0, 0, 0, 0.98);\n    backdrop-filter: blur(20px);\n    flex-direction: column;\n    padding: 2rem;\n    gap: 1.5rem;\n    transform: translateY(-100%);\n    transition: transform 0.3s ease;\n    z-index: 999;\n    display: flex;\n  }\n  \n  .nav-menu.mobile-open {\n    transform: translateY(0);\n  }\n  \n  .nav-item {\n    font-size: 18px;\n    padding: 10px 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  }\n}\n\n.hero-section {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 0 48px;\n  padding-top: 80px;\n  position: relative;\n}\n\n.hero-title {\n  font-size: 32px;\n  font-weight: 300;\n  line-height: 1.2;\n  text-align: center;\n  margin-bottom: 20px;\n  letter-spacing: -0.5px;\n  max-width: 700px;\n  animation: fadeInUp 1s ease;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n.hero-subtitle {\n  font-size: 16px;\n  line-height: 1.5;\n  color: rgba(255, 255, 255, 0.5);\n  text-align: center;\n  margin-bottom: 48px;\n  max-width: 500px;\n  animation: fadeInUp 1s ease 0.2s;\n  animation-fill-mode: both;\n  font-weight: 300;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n/* Sphere Container */\n.sphere-container {\n  width: 500px;\n  height: 500px;\n  margin: 60px auto;\n  border-radius: 50%;\n  overflow: hidden;\n  position: relative;\n}\n\n/* Metrics */\n.metrics {\n  position: absolute;\n  bottom: 60px;\n  left: 48px;\n  display: flex;\n  gap: 60px;\n  animation: fadeInUp 1s ease 0.8s;\n  animation-fill-mode: both;\n}\n\n.metric-item {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.metric-item label {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.5);\n  font-weight: 400;\n}\n\n.metric-value {\n  font-size: 24px;\n  font-weight: 500;\n  color: #ffffff;\n  letter-spacing: -0.5px;\n}\n\n/* Scroll Indicator */\n.scroll-indicator {\n  position: absolute;\n  bottom: 60px;\n  right: 48px;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.5);\n  animation: fadeIn 1s ease 1s;\n  animation-fill-mode: both;\n}\n\n/* Update Particle Sphere Container Styles */\n.particles-sphere-container {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n.particles-canvas {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.sphere-logo {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 60px;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border-radius: 50%;\n}\n\n.logo-v {\n  font-size: 32px;\n  font-weight: 300;\n  color: #ffffff;\n  opacity: 0.9;\n}\n\n/* Animations */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Responsive */\n@media (max-width: 1280px) {\n  .navbar-container {\n    padding: 0 32px;\n  }\n  \n  .hero-title {\n    font-size: 52px;\n  }\n  \n  .section-container {\n    max-width: 1100px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .logo-image {\n    height: 100px;\n  }\n  \n  .nav-item {\n    font-size: 18px;\n  }\n  \n  .launch-btn {\n    font-size: 18px;\n    padding: 8px 20px;\n  }\n  \n  .hero-title {\n    font-size: 44px;\n  }\n  \n  .sphere-container {\n    width: 400px;\n    height: 400px;\n    border-radius: 50%;\n  }\n  \n  .value-cards {\n    flex-direction: column;\n    max-width: 600px;\n    margin: 0 auto;\n  }\n  \n  .value-card {\n    width: 100%;\n  }\n  \n  .tech-features {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 2rem;\n    padding: 0 2rem;\n  }\n}\n\n@media (max-width: 768px) {\n  /* Navigation */\n  .navbar {\n    height: 60px;\n    padding: 0 20px;\n  }\n  \n  .navbar-container {\n    padding: 0 0;\n  }\n  \n  .logo-image {\n    height: 80px;\n  }\n  \n  .nav-right {\n    gap: 20px;\n  }\n  \n  .nav-menu {\n    display: none;\n  }\n  \n  .launch-btn {\n    font-size: 14px;\n    padding: 8px 16px;\n  }\n  \n  /* Hero Section */\n  .hero-section {\n    padding: 0 20px;\n    padding-top: 100px;\n  }\n  \n  .hero-title {\n    font-size: 32px;\n    line-height: 1.3;\n  }\n  \n  .hero-subtitle {\n    font-size: 16px;\n    padding: 0 20px;\n  }\n  \n  .sphere-container {\n    position: relative;\n    width: 500px;\n    height: 500px;\n    margin: 60px auto;\n    border-radius: 50%;\n    overflow: hidden;\n  }\n  \n  .metrics {\n    position: relative;\n    left: auto;\n    bottom: auto;\n    flex-direction: row;\n    justify-content: center;\n    gap: 30px;\n    margin-top: 40px;\n  }\n  \n  .scroll-indicator {\n    display: none;\n  }\n  \n  /* Partners Section */\n  .partners-section {\n    padding: 4rem 1rem;\n    min-height: auto;\n  }\n  \n  .section-title {\n    font-size: 32px;\n  }\n  \n  .section-subtitle {\n    font-size: 16px;\n  }\n  \n  /* Value Cards */\n  .value-cards {\n    gap: 20px;\n  }\n  \n  /* Technology Section */\n  .technology-section {\n    padding: 4rem 1rem;\n  }\n  \n  .tech-features {\n    grid-template-columns: 1fr;\n    gap: 2.5rem;\n    padding-top: 40px;\n  }\n  \n  .tech-feature {\n    max-width: 300px;\n    margin: 0 auto;\n  }\n  \n  .feature-icon {\n    font-size: 2.5rem;\n  }\n  \n  .tech-feature h4 {\n    font-size: 20px;\n  }\n  \n  .tech-feature p {\n    font-size: 16px;\n  }\n  \n  /* Code Block */\n  .code-block-container {\n    padding: 0 1rem;\n    margin: 2rem 0;\n  }\n  \n  .code-tabs {\n    flex-wrap: wrap;\n    gap: 1rem;\n  }\n  \n  .code-tab {\n    font-size: 14px;\n    padding: 8px 16px;\n  }\n  \n  .code-window {\n    max-width: 100%;\n  }\n  \n  .code-content-wrapper {\n    min-height: 400px;\n    height: 50vh;\n  }\n  \n  .code-block-container .code-content {\n    padding: 2rem;\n    font-size: 14px;\n    line-height: 24px;\n  }\n}\n\n@media (max-width: 480px) {\n  /* Mobile Navigation */\n  .logo-image {\n    height: 60px;\n  }\n  \n  .nav-item {\n    display: none;\n  }\n  \n  .launch-btn {\n    font-size: 13px;\n    padding: 6px 14px;\n    border-radius: 18px;\n  }\n  \n  /* Hero Section */\n  .hero-title {\n    font-size: 28px;\n  }\n  \n  .hero-subtitle {\n    font-size: 14px;\n    line-height: 1.6;\n  }\n  \n  .sphere-container {\n    width: 250px;\n    height: 250px;\n    border-radius: 50%;\n  }\n  \n  .metric {\n    font-size: 12px;\n  }\n  \n  .metric-value {\n    font-size: 20px;\n  }\n  \n  /* Sections */\n  .section-title {\n    font-size: 28px;\n    margin-bottom: 1rem;\n  }\n  \n  .section-subtitle {\n    font-size: 14px;\n    margin-bottom: 2rem;\n  }\n  \n  /* Tech Features */\n  .feature-icon {\n    font-size: 2rem;\n  }\n  \n  .tech-feature h4 {\n    font-size: 18px;\n  }\n  \n  .tech-feature p {\n    font-size: 14px;\n  }\n  \n  /* Code Block */\n  .code-tab {\n    font-size: 12px;\n    padding: 6px 12px;\n  }\n  \n  .code-block-container .code-content {\n    padding: 1.5rem;\n    font-size: 12px;\n    line-height: 20px;\n  }\n  \n  .code-content-wrapper {\n    min-height: 300px;\n  }\n  \n  /* CTA Section */\n  .cta-title {\n    font-size: 28px;\n  }\n  \n  .cta-subtitle {\n    font-size: 14px;\n  }\n  \n  .cta-buttons {\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .cta-btn {\n    width: 100%;\n    padding: 12px 24px;\n  }\n  \n  /* Footer */\n  .footer-section {\n    padding: 3rem 1rem;\n  }\n  \n  .footer-content {\n    flex-direction: column;\n    gap: 2rem;\n    text-align: center;\n  }\n  \n  .footer-links {\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .footer-link {\n    font-size: 14px;\n  }\n}\n\n/* Partners Section */\n.partners-section {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6rem 2rem;\n  background: #000000;\n}\n\n.section-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.section-title {\n  font-size: 48px;\n  font-weight: 600;\n  text-align: center;\n  margin-bottom: 1.5rem;\n  letter-spacing: -1px;\n}\n\n.section-subtitle {\n  font-size: 18px;\n  color: rgba(255, 255, 255, 0.6);\n  text-align: center;\n  margin-bottom: 4rem;\n  line-height: 1.6;\n}\n\n/* Partner Logos */\n.partners-container {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  padding: 2rem 0;\n}\n\n.partners-row {\n  display: flex;\n  gap: 2rem;\n  white-space: nowrap;\n}\n\n.partner-logo {\n  flex-shrink: 0;\n  padding: 1rem;\n}\n\n.logo-box {\n  width: 180px;\n  height: 80px;\n  border-radius: 12px;\n  border: 1px solid;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n}\n\n/* Solutions Section */\n.solutions-section {\n  min-height: 100vh;\n  padding: 6rem 2rem;\n  background: #000000;\n}\n\n.value-cards-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 2rem;\n  margin-top: 4rem;\n}\n\n.value-card {\n  background: rgba(10, 10, 10, 0.8);\n  border: 1px solid rgba(65, 105, 225, 0.2);\n  border-radius: 20px;\n  padding: 2rem;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n  overflow: hidden;\n  min-height: 400px;\n  display: flex;\n  flex-direction: column;\n}\n\n.value-card:hover {\n  border-color: rgba(65, 105, 225, 0.5);\n  background: rgba(65, 105, 225, 0.08);\n  transform: translateY(-5px);\n}\n\n.card-content {\n  flex: 1;\n  margin-bottom: 2rem;\n}\n\n.card-title {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  color: #ffffff;\n}\n\n.card-subtitle {\n  font-size: 14px;\n  font-weight: 400;\n  color: rgba(65, 105, 225, 0.8);\n  margin-bottom: 1rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.card-description {\n  font-size: 14px;\n  line-height: 1.6;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.card-visual {\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 12px;\n  padding: 1rem;\n  margin-top: auto;\n}\n\n/* Dashboard Visual */\n.visual-dashboard {\n  font-size: 12px;\n  width: 100%;\n  height: 100%;\n}\n\n.dashboard-header {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n  border-bottom: 1px solid rgba(65, 105, 225, 0.2);\n  padding-bottom: 0.5rem;\n}\n\n.dashboard-tab {\n  padding: 0.25rem 0.5rem;\n  color: rgba(255, 255, 255, 0.5);\n  cursor: pointer;\n  transition: all 0.2s;\n  font-size: 11px;\n}\n\n.dashboard-tab.active {\n  color: #4169E1;\n  border-bottom: 2px solid #4169E1;\n}\n\n.metric-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.metric-label {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.metric-value {\n  color: #ffffff;\n  font-weight: 500;\n}\n\n.metric-value.positive {\n  color: #10b981;\n}\n\n.chart-placeholder {\n  margin-top: 1rem;\n  width: 100%;\n  height: 60px;\n}\n\n.mini-chart {\n  height: 60px;\n  width: 100%;\n  display: block;\n}\n\n/* Code Visual for Value Cards - Small Code Blocks */\n.visual-code {\n  font-size: 11px;\n}\n\n.visual-code .code-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem;\n  background: rgba(65, 105, 225, 0.1);\n  border-radius: 8px 8px 0 0;\n  margin-bottom: 0.5rem;\n}\n\n.visual-code .code-file {\n  color: #4169E1;\n  font-weight: 500;\n  font-size: 11px;\n}\n\n.visual-code .code-dots {\n  display: flex;\n  gap: 4px;\n}\n\n.visual-code .code-dots span {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.visual-code .code-content {\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 0 0 8px 8px;\n  padding: 1rem;\n  overflow-x: auto;\n  max-height: 200px;\n}\n\n.visual-code .code-content pre {\n  margin: 0;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.visual-code .code-content code {\n  color: #e2e8f0;\n  font-family: 'Consolas', 'Monaco', monospace;\n  font-size: 11px;\n  line-height: 1.4;\n}\n\n/* Interface Visual */\n.visual-interface {\n  font-size: 12px;\n}\n\n.interface-header {\n  margin-bottom: 1rem;\n}\n\n.interface-nav {\n  display: flex;\n  gap: 1rem;\n  border-bottom: 1px solid rgba(65, 105, 225, 0.2);\n  padding-bottom: 0.5rem;\n}\n\n.interface-nav .nav-item {\n  color: rgba(255, 255, 255, 0.5);\n  cursor: pointer;\n  padding: 0.25rem 0;\n  transition: all 0.2s;\n}\n\n.interface-nav .nav-item.active {\n  color: #4169E1;\n  border-bottom: 2px solid #4169E1;\n}\n\n.balance-card {\n  background: rgba(65, 105, 225, 0.1);\n  padding: 1rem;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.balance-label {\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.balance-amount {\n  color: #ffffff;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.position-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.position-item {\n  display: flex;\n  justify-content: space-between;\n  padding: 0.75rem;\n  background: rgba(255, 255, 255, 0.02);\n  border-radius: 6px;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.position-token {\n  color: #ffffff;\n  font-weight: 500;\n}\n\n.position-apy {\n  color: #10b981;\n  font-weight: 500;\n}\n\n/* Responsive */\n@media (max-width: 1200px) {\n  .value-cards-grid {\n    grid-template-columns: 1fr;\n    max-width: 600px;\n    margin: 4rem auto 0;\n  }\n}\n\n/* Technology Section */\n.technology-section {\n  min-height: 100vh;\n  padding: 6rem 2rem;\n  background: #000000;\n}\n\n/* Code Block Styles */\n.code-block-container {\n  max-width: 100%;\n  margin: 4rem 0;\n  padding: 0 2rem;\n}\n\n.code-tabs {\n  display: flex;\n  gap: 2rem;\n  margin-bottom: 2rem;\n  border-bottom: 1px solid rgba(100, 150, 255, 0.1);\n}\n\n.code-tab {\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 14px;\n  font-weight: 500;\n  padding: 1rem 0;\n  cursor: pointer;\n  position: relative;\n  transition: all 0.3s ease;\n}\n\n.code-tab:hover {\n  color: rgba(100, 150, 255, 0.9);\n}\n\n.code-tab.active {\n  color: #64B5F6;\n}\n\n.code-tab.active::after {\n  content: '';\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: linear-gradient(90deg, #64B5F6 0%, #42A5F5 100%);\n}\n\n.code-window {\n  background: linear-gradient(135deg, #0d1117 0%, #0a0f1b 50%, #081320 100%);\n  border: 1px solid rgba(100, 150, 255, 0.2);\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 20px 60px rgba(100, 150, 255, 0.15);\n  width: 100%;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.code-block-container .code-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 1.5rem;\n  background: linear-gradient(180deg, rgba(100, 150, 255, 0.05) 0%, transparent 100%);\n  border-bottom: 1px solid rgba(100, 150, 255, 0.1);\n}\n\n.code-block-container .code-filename {\n  color: #64B5F6;\n  font-size: 14px;\n  font-family: 'JetBrains Mono', 'Consolas', 'Monaco', monospace;\n  font-weight: 500;\n}\n\n.code-actions {\n  display: flex;\n  gap: 1rem;\n}\n\n.code-action {\n  background: rgba(100, 150, 255, 0.05);\n  border: 1px solid rgba(100, 150, 255, 0.2);\n  color: #64B5F6;\n  font-size: 12px;\n  padding: 0.25rem 0.75rem;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.code-action:hover {\n  background: rgba(100, 150, 255, 0.15);\n  border-color: rgba(100, 150, 255, 0.4);\n  color: #90CAF9;\n}\n\n.code-content-wrapper {\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(135deg, rgba(13, 17, 23, 0.95) 0%, rgba(8, 19, 32, 0.98) 100%);\n  min-height: 800px;\n  height: 80vh;\n  max-height: 900px;\n  overflow: auto;\n  position: relative;\n}\n\n.code-line-numbers {\n  display: none; /* Hide line numbers */\n}\n\n.line-number {\n  display: none; /* Hide line numbers */\n}\n\n.code-block-container .code-content {\n  width: 100%;\n  height: 100%;\n  min-height: 800px;\n  margin: 0;\n  padding: 4rem;\n  overflow: auto;\n  background: transparent;\n  color: #e0e6ed;\n  font-family: 'JetBrains Mono', 'Fira Code', 'Consolas', monospace;\n  font-size: 18px;\n  line-height: 32px;\n  letter-spacing: 0.8px;\n  font-weight: 400;\n  display: flex;\n  flex-direction: column;\n}\n\n.code-block-container .code-content pre {\n  margin: 0;\n  padding: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: 32px;\n  flex: 1;\n  width: 100%;\n  height: 100%;\n}\n\n.code-block-container .code-content code {\n  display: block;\n  white-space: pre;\n  color: inherit;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: 32px;\n  width: 100%;\n  height: 100%;\n}\n\n/* Syntax highlighting with light blue theme */\n.code-content .keyword {\n  color: #64B5F6;\n  font-weight: 500;\n}\n\n.code-content .string {\n  color: #81C784;\n}\n\n.code-content .comment {\n  color: #546E7A;\n  font-style: italic;\n}\n\n.code-content .number {\n  color: #FFB74D;\n}\n\n.code-content .function {\n  color: #4FC3F7;\n  font-weight: 500;\n}\n\n.code-content .type {\n  color: #BA68C8;\n}\n\n.code-content .variable {\n  color: #90CAF9;\n}\n\n/* Scrollbar styling */\n.code-content-wrapper::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n.code-content-wrapper::-webkit-scrollbar-track {\n  background: #0a0a0a;\n}\n\n.code-content-wrapper::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 5px;\n}\n\n.code-content-wrapper::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.tech-header {\n  text-align: center;\n  margin-bottom: 4rem;\n}\n\n.gradient-text {\n  background: linear-gradient(135deg, #4169E1 0%, #5179F1 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.tech-features {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 3rem;\n  max-width: 1000px;\n  margin: 4rem auto 0;\n}\n\n.tech-feature {\n  text-align: center;\n  padding: 0;\n  background: transparent;\n  border: none;\n  transition: all 0.3s ease;\n}\n\n.tech-feature:hover {\n  transform: translateY(-5px);\n}\n\n.feature-icon {\n  font-size: 2rem;\n  margin-bottom: 0.5rem;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.tech-feature h4 {\n  font-size: 16px;\n  font-weight: 500;\n  color: #ffffff;\n  margin-bottom: 0.5rem;\n}\n\n.tech-feature p {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n/* CTA Section */\n.cta-section {\n  min-height: 60vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6rem 2rem;\n  background: #000000;\n}\n\n.cta-content {\n  text-align: center;\n}\n\n.cta-title {\n  font-size: 48px;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  background: linear-gradient(135deg, #4169E1 0%, #5179F1 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.cta-subtitle {\n  font-size: 20px;\n  color: rgba(255, 255, 255, 0.7);\n  margin-bottom: 3rem;\n}\n\n.cta-buttons {\n  display: flex;\n  gap: 1.5rem;\n  justify-content: center;\n}\n\n.cta-primary {\n  padding: 14px 32px;\n  background: #4169E1;\n  border: none;\n  border-radius: 20px;\n  color: white;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.cta-primary:hover {\n  background: #5179F1;\n  transform: translateY(-2px);\n}\n\n.cta-secondary {\n  padding: 14px 32px;\n  background: transparent;\n  border: 2px solid rgba(65, 105, 225, 0.5);\n  border-radius: 20px;\n  color: #ffffff;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.cta-secondary:hover {\n  background: rgba(65, 105, 225, 0.1);\n  border-color: #4169E1;\n}\n\n/* Footer */\n.vega-footer {\n  background: #0a0a0a;\n  border-top: 1px solid rgba(65, 105, 225, 0.1);\n  padding: 4rem 2rem 2rem;\n}\n\n.footer-container {\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.footer-content {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 4rem;\n  margin-bottom: 3rem;\n}\n\n.footer-brand p {\n  color: rgba(255, 255, 255, 0.5);\n  margin-top: 1rem;\n}\n\n.footer-logo {\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.logo-accent {\n  color: #4169E1;\n}\n\n.footer-links {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 2rem;\n}\n\n.footer-column h5 {\n  font-size: 14px;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: rgba(255, 255, 255, 0.5);\n  margin-bottom: 1rem;\n}\n\n.footer-column a {\n  display: block;\n  color: rgba(255, 255, 255, 0.7);\n  text-decoration: none;\n  padding: 0.25rem 0;\n  transition: color 0.3s ease;\n}\n\n.footer-column a:hover {\n  color: #4169E1;\n}\n\n.footer-bottom {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 2rem;\n  border-top: 1px solid rgba(65, 105, 225, 0.1);\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.footer-socials {\n  display: flex;\n  gap: 2rem;\n}\n\n.footer-socials a {\n  color: rgba(255, 255, 255, 0.7);\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.footer-socials a:hover {\n  color: #4169E1;\n}\n\n/* Hero Section Updates */\n.hero-subtitle-large {\n  font-size: 20px;\n  line-height: 1.5;\n  color: rgba(100, 150, 255, 0.9);\n  text-align: center;\n  margin-bottom: 24px;\n  max-width: 600px;\n  animation: fadeInUp 1s ease 0.15s;\n  animation-fill-mode: both;\n  font-weight: 500;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  letter-spacing: 0.5px;\n}\n\n.hero-description {\n  font-size: 16px;\n  line-height: 1.7;\n  color: rgba(255, 255, 255, 0.5);\n  text-align: center;\n  margin-bottom: 40px;\n  max-width: 650px;\n  animation: fadeInUp 1s ease 0.3s;\n  animation-fill-mode: both;\n  font-weight: 300;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n.hero-cta-buttons {\n  display: flex;\n  gap: 1.5rem;\n  justify-content: center;\n  animation: fadeInUp 1s ease 0.45s;\n  animation-fill-mode: both;\n  margin-bottom: 20px;\n}\n\n/* About Section Cards */\n.about-details-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 2rem;\n  margin-top: 3rem;\n}\n\n.about-card {\n  background: rgba(10, 10, 10, 0.8);\n  border: 1px solid rgba(65, 105, 225, 0.2);\n  border-radius: 16px;\n  padding: 2rem;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n}\n\n.about-card:hover {\n  border-color: rgba(65, 105, 225, 0.5);\n  background: rgba(65, 105, 225, 0.08);\n  transform: translateY(-4px);\n}\n\n.about-card h4 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #4169E1;\n  margin-bottom: 1rem;\n}\n\n.about-card p {\n  font-size: 15px;\n  line-height: 1.7;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n/* Second row of value cards */\n.value-cards-grid-second {\n  margin-top: 2rem;\n}\n\n/* Second row of tech features */\n.tech-features-second {\n  margin-top: 3rem;\n}\n\n/* Approach Section */\n.approach-section {\n  min-height: 80vh;\n  padding: 6rem 2rem;\n  background: #000000;\n  display: flex;\n  align-items: center;\n}\n\n.approach-pillars {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 2rem;\n  margin-top: 4rem;\n}\n\n.pillar-card {\n  background: rgba(10, 10, 10, 0.8);\n  border: 1px solid rgba(65, 105, 225, 0.2);\n  border-radius: 20px;\n  padding: 2.5rem;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n  text-align: center;\n}\n\n.pillar-card:hover {\n  border-color: rgba(65, 105, 225, 0.5);\n  background: rgba(65, 105, 225, 0.08);\n  transform: translateY(-5px);\n}\n\n.pillar-number {\n  font-size: 48px;\n  font-weight: 700;\n  color: rgba(65, 105, 225, 0.3);\n  margin-bottom: 1rem;\n  font-family: 'Inter', sans-serif;\n}\n\n.pillar-card h3 {\n  font-size: 22px;\n  font-weight: 600;\n  color: #ffffff;\n  margin-bottom: 1rem;\n}\n\n.pillar-card p {\n  font-size: 15px;\n  line-height: 1.7;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n/* Contact Section */\n.contact-content {\n  width: 100%;\n}\n\n.contact-grid {\n  display: grid;\n  grid-template-columns: 1fr 1.5fr;\n  gap: 4rem;\n  margin-top: 3rem;\n  text-align: left;\n}\n\n.contact-info {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.contact-info-card {\n  background: rgba(10, 10, 10, 0.6);\n  border: 1px solid rgba(65, 105, 225, 0.15);\n  border-radius: 12px;\n  padding: 1.25rem 1.5rem;\n}\n\n.contact-info-card h4 {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: rgba(65, 105, 225, 0.8);\n  margin-bottom: 0.5rem;\n}\n\n.contact-info-card p {\n  font-size: 15px;\n  color: rgba(255, 255, 255, 0.8);\n  line-height: 1.6;\n}\n\n.contact-info-card a {\n  color: rgba(255, 255, 255, 0.8);\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.contact-info-card a:hover {\n  color: #4169E1;\n}\n\n/* Contact Form */\n.contact-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.form-group label {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.6);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.form-group input,\n.form-group textarea {\n  background: rgba(10, 10, 10, 0.8);\n  border: 1px solid rgba(65, 105, 225, 0.2);\n  border-radius: 10px;\n  padding: 12px 16px;\n  color: #ffffff;\n  font-size: 15px;\n  font-family: 'Inter', sans-serif;\n  transition: all 0.3s ease;\n  outline: none;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  border-color: #4169E1;\n  box-shadow: 0 0 0 3px rgba(65, 105, 225, 0.1);\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 120px;\n}\n\n.form-submit-btn {\n  width: 100%;\n  margin-top: 0.5rem;\n}\n\n.form-success {\n  background: rgba(65, 105, 225, 0.1);\n  border: 1px solid rgba(65, 105, 225, 0.3);\n  border-radius: 12px;\n  padding: 2rem;\n  text-align: center;\n}\n\n.form-success p {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 16px;\n}\n\n/* Footer Updates */\n.footer-brand .footer-licence {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.4);\n  margin-top: 0.75rem;\n}\n\n.logo-fzco {\n  color: rgba(255, 255, 255, 0.5);\n  font-weight: 400;\n  font-size: 16px;\n}\n\n.footer-address {\n  text-align: center;\n  padding: 1.5rem 0;\n  border-top: 1px solid rgba(65, 105, 225, 0.1);\n  margin-top: 2rem;\n}\n\n.footer-address p {\n  color: rgba(255, 255, 255, 0.4);\n  font-size: 14px;\n}\n\n.footer-disclaimer {\n  padding: 1.5rem 0;\n  border-top: 1px solid rgba(65, 105, 225, 0.1);\n}\n\n.footer-disclaimer p {\n  color: rgba(255, 255, 255, 0.35);\n  font-size: 12px;\n  line-height: 1.7;\n  text-align: center;\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n/* Responsive Updates */\n@media (max-width: 1200px) {\n  .about-details-grid {\n    grid-template-columns: 1fr;\n    max-width: 600px;\n    margin: 3rem auto 0;\n  }\n  \n  .approach-pillars {\n    grid-template-columns: 1fr;\n    max-width: 600px;\n    margin: 4rem auto 0;\n  }\n\n  .contact-grid {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .hero-subtitle-large {\n    font-size: 17px;\n  }\n\n  .hero-description {\n    font-size: 14px;\n    padding: 0 10px;\n  }\n\n  .hero-cta-buttons {\n    flex-direction: column;\n    align-items: center;\n    gap: 1rem;\n  }\n\n  .about-details-grid {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n  \n  .approach-section {\n    padding: 4rem 1rem;\n  }\n\n  .approach-pillars {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n\n  .contact-grid {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n  }\n\n  .footer-content {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n  }\n\n  .footer-links {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n\n  .footer-address,\n  .footer-disclaimer {\n    padding: 1rem 0;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero-subtitle-large {\n    font-size: 15px;\n  }\n\n  .hero-description {\n    font-size: 13px;\n  }\n\n  .about-card {\n    padding: 1.5rem;\n  }\n\n  .pillar-card {\n    padding: 1.5rem;\n  }\n\n  .pillar-number {\n    font-size: 36px;\n  }\n\n  .contact-info-card {\n    padding: 1rem;\n  }\n}\n\n/* End of styles */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
